<template>
  <div class="about">
    <div class="md-layout">
      <div class="md-layout-item md-small-size-100">
        <div class="center-form">
          <formulario />
        </div>
      </div>
      <div class="md-layout-item md-small-size-100 map">
        <div class="center-form" style="height: 100%">
          <div class="md-elevation-10 form-card card-map" style="height: 100%">
             <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3329.259416203457!2d-70.62804178518049!3d-33.442547304491974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662c57f661fd7fd%3A0x3c352e62142bf12c!2sAv.%20Italia%20850%2C%20Providencia%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses!2scl!4v1601928150447!5m2!1ses!2scl" width="600" height="600" frameborder="2" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Formulario from '../components/Form'
export default {
  //metaInfo: {
  //  title: 'Green Solutions | Contáctanos'
  //},
  components: {Formulario}
}
</script>

<style scoped>
.map > div > div > iframe {
  height: 100% !important;
  border-radius: 25px;
}
.about {
  padding: 10px;
}
.about h1 {
  padding: 20px;
}
.center-form {
  width: 100%;
  margin: auto;
  padding: 3vw;
}

.center-form div.card-map {
  width: 70%;
  margin: auto;
}

.btn-green {
  top: 2.5% !important
}
</style>